import { render, staticRenderFns } from "./Application2.vue?vue&type=template&id=85400f94"
import script from "./Application2.vue?vue&type=script&lang=js"
export * from "./Application2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports